module.exports = __webpack_public_path__ + "media/images/about/history/president-3-8c3268721c7e721702553b8bb5d5ccf0.png";